import { AuthenticateOptions } from '@aparajita/capacitor-biometric-auth';

export const BIOMETRIC_AUTH_OPTIONS: AuthenticateOptions = {
	cancelTitle: 'Скасувати',
	androidTitle: 'Біометрична автентифікація HOST',
	allowDeviceCredential: false,
};
